import Control from "../../../components/control-panel/control";
import Page from "../../page";

const ControlPanelPage = () => {
  return (
    <Page>
      <Control />
    </Page>
  );
};

export default ControlPanelPage;
